import React, { useState } from "react";
import "../../../../style/main.scss";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Icon } from "@iconify/react";

const MagicModal = ({ show, handleClose }) => {
  // const [show, setShow] = useState(false);

  // const handleClose = () => setShow(false);
  // const handleShow = () => setShow(true);
  return (
    <>
      {/* Magic Modal  */}

      <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header>
        <Modal.Body className="magic-modal-body">
          <h4>How do you want to magically generate a script?</h4>
          <div className="radios mt-5">
            <label htmlFor="1">
              <div className="radio-btns">
                <div className="two">
                  <h6>Upload a call recording</h6>
                  <p>
                    Clone your best rep by uploading a call recording. voxr will
                    take their call recording, transcribe it, and create a
                    framework from it that your agent can follow.
                  </p>
                </div>
              </div>
            </label>
            <label htmlFor="2">
              <div className="radio-btns ">
                <div className="two">
                  <h6>Give voxr your existing script</h6>
                  <p>
                    Copy and paste your current script and let voxr reformat it
                    an a way that is easy for your agent to follow.
                  </p>
                </div>
              </div>
            </label>
            <label htmlFor="3">
              <div className="radio-btns  ">
                <div className="two">
                  <h6>Use a proven template from voxr</h6>
                  <p>
                    Select a proven template, give voxr some basic context, and
                    have AI customize it for your business.
                  </p>
                </div>
              </div>
            </label>
          </div>
          {/* <Button variant="primary" onClick={handleClose} className="mt-5">
            Use Selected Magic Generation Type
          </Button> */}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MagicModal;
